import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
import Form from 'components/form/Form';
import DrawerPanel from 'components/drawer-panel/DrawerPanel';
export default class ProfileForm extends Component {
    bindEvents(add = true) {
        super.bindEvents();
        const method = bindMethod(add);
        this.refs.toggleEditPassword[method]('click', this.toggleEditPassword);
    }
    getModulesMap() {
        return {
            drawer: ['.profile__form-edit-password-drawer', DrawerPanel],
            form: ['.form', Form]
        };
    }
    getModuleParams(el, componentConstructor) {
        return {
            ...super.getModuleParams(el, componentConstructor),
            pageManager: this.options.pageManager
        };
    }
    toggle = (value) => {
        this.el.classList.toggle('visible', value);
        this.modules.drawer.resize();
    };
    toggleEditPassword = (e) => {
        const t = e.currentTarget;
        this.refs.editPassword.classList.toggle('opened', t.checked);
        const attributeMethod = t.checked ? 'setAttribute' : 'removeAttribute';
        this.refs.newPassword[attributeMethod]('data-required', '');
        this.refs.newPassword[attributeMethod]('data-validation', 'password');
        this.refs.newPasswordConfirm[attributeMethod]('data-required', '');
        this.refs.newPasswordConfirm[attributeMethod]('data-validation', 'passwordConfirm');
        this.modules.form.parseForm();
    };
}
